/** Коды причин жалобы на участника проекта (кросс-клиентский контракт с бэком 18258 и мобилкой) */
export const PARTICIPANT_COMPLAINT_REASON_CODES = [
  'not_in_project',
  'added_without_consent',
  'left_project',
  'other'
] as const;

export type TParticipantComplaintReason =
  (typeof PARTICIPANT_COMPLAINT_REASON_CODES)[number];

/** Причина, требующая комментария */
export const PARTICIPANT_COMPLAINT_OTHER_REASON: TParticipantComplaintReason =
  'other';

/**
 * Причины «Это я…»: бэк принимает их только от самого участника или если участника
 * нет на платформе (визитка not_registered) — иначе 422
 */
export const PARTICIPANT_COMPLAINT_SELF_REASONS: TParticipantComplaintReason[] =
  ['added_without_consent', 'left_project'];

/** Подписи причин; порядок ключей — порядок в форме */
export const PARTICIPANT_COMPLAINT_REASON_LABELS: Record<
  TParticipantComplaintReason,
  string
> = {
  not_in_project: 'Этот человек не снимается в проекте',
  added_without_consent: 'Это я, меня добавили без моего согласия',
  left_project: 'Это я, я больше не участвую в этом проекте',
  other: 'Другое'
};

/** Предел длины комментария к жалобе (как на бэке) */
export const PARTICIPANT_COMPLAINT_COMMENT_MAX_LENGTH = 1000;

/** apiPath ресурса «Жалобы на участников» в admin-v2 */
export const PARTICIPANT_COMPLAINT_CASES_API_PATH =
  'moderation/participant_complaint_cases';

/**
 * Статусы дела по жалобам на участника: средний род («Новое», «Отклонено»), порядок — как
 * в селекте. `confirmed` — «Подтверждено», а не «Участник скрыт»: после «Показать
 * участника» дело остаётся подтверждённым; факт скрытия виден отдельно («Скрыт» в шапке,
 * «(скрыт)» в списке)
 */
export const PARTICIPANT_COMPLAINT_CASE_STATUS_LABELS: Record<string, string> =
  {
    new: 'Новое',
    in_progress: 'В работе',
    confirmed: 'Подтверждено',
    rejected: 'Отклонено'
  };

/** Статусы дела как опции селекта фильтра списка */
export const PARTICIPANT_COMPLAINT_CASE_STATUS_OPTIONS = Object.entries(
  PARTICIPANT_COMPLAINT_CASE_STATUS_LABELS
).map(([value, label]) => ({ label, value }));

/** Тон пилюли статуса дела — один источник для списка и карточки */
export const PARTICIPANT_COMPLAINT_CASE_STATUS_TONE = {
  new: 'warning',
  in_progress: 'info',
  confirmed: 'success',
  rejected: 'neutral'
} as const;

/** Статус «Подтверждено» — решение «Скрыть участника»: требует причину, которую увидит режиссёр */
export const PARTICIPANT_COMPLAINT_HIDE_STATUS = 'confirmed';

/** Действие панели решения: подпись, целевой статус и вид кнопки */
export interface IParticipantComplaintCaseAction {
  label: string;
  status: string;
  variant: 'primary' | 'success' | 'danger' | 'secondary';
}

/** Кнопки панели решения по текущему статусу дела */
export const PARTICIPANT_COMPLAINT_CASE_ACTIONS: Record<
  string,
  IParticipantComplaintCaseAction[]
> = {
  new: [
    { label: 'Взять в работу', status: 'in_progress', variant: 'primary' },
    { label: 'Скрыть участника', status: 'confirmed', variant: 'danger' },
    { label: 'Отклонить', status: 'rejected', variant: 'secondary' }
  ],
  in_progress: [
    { label: 'Скрыть участника', status: 'confirmed', variant: 'danger' },
    { label: 'Отклонить', status: 'rejected', variant: 'secondary' },
    { label: 'Вернуть в новые', status: 'new', variant: 'secondary' }
  ],
  confirmed: [
    { label: 'Вернуть в работу', status: 'in_progress', variant: 'secondary' }
  ],
  rejected: [
    { label: 'Вернуть в работу', status: 'in_progress', variant: 'secondary' }
  ]
};
